export const loginRequestB2C = {
    scopes: ['openid', 'offline_access'],
    redirectUri: '/',
};
